import NewsPage from "../news/NewsPage";
import Mpdata from "../../pages/mp/Mpdata";

const sports = () => {
  return (
    <NewsPage
      categoryAliases={["sports", "sport", "khel", "खेल"]}
      staticData={[Mpdata]} // optional
    />
  );
};

export default sports;
